import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Icon from 'components/Icon';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  paper: {
    width: '522px',
    maxWidth: 'calc(100% - 32px)',
    borderRadius: '16px',
    padding: '24px',
    '& .MuiDialogTitle-root': {
      padding: 0,
      fontSize: '20px',
      marginBottom: '24px',
      position: 'relative',
      paddingRight: '32px',
      '& .closeIcon': {
        position: 'absolute',
        width: '14px',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
      },
    },
    '& .MuiDialogContent-root': {
      padding: 0,
      fontSize: '16px',
      fontWeight: 400,
      color: '#637381',
      marginBottom: '24px',
    },
    '& .MuiDialogActions-root': {
      padding: 0,
    },
  },
});

const BookNotFoundModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={useStyles()}
      aria-labelledby="book-not-found-title"
      aria-describedby="book-not-found-description"
    >
      <DialogTitle id="book-not-found-title">
        找不到書本
        <div className="closeIcon" onClick={onClose}>
          <Icon name="CloseNotification" />
        </div>
      </DialogTitle>
      <DialogContent id="book-not-found-description">
        此本書不存在，可能連結有誤。建議您至書櫃查找所需書本。
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onConfirm}
          variant="contained"
          style={{ background: '#121232', color: 'white', whiteSpace: 'nowrap', padding: '8px 16px', minWidth: 'auto', width: 'auto' }}
        >
          前往書櫃
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BookNotFoundModal;
